import React, { useState } from "react";
import { useGetConsentsQuery } from "../../redux/service/demographic_services";
import { AppListing } from "../../components/appListing";
import { capitalizeFirstLetter, formattedDatePp, getBaseUrl } from "../../utils/common_lib";
import MainPageDialog from "../../components/mainPageDialog";
import { getFileUrl } from "../care_plan/constant";
import { getUser } from "../../userStore";

function Consent({ crossHandler }) {
  const userData = getUser();
  const [previewData, setPreviewData] = useState(null);
  const { data: consentData, isLoading } = useGetConsentsQuery();
  const cols = [
    {
      title: "Type",
      getData: (item) => capitalizeFirstLetter(item?.type),

    },
    { title: "Category", key: "category" ,},
    {
      title: "Start Date",
      getData: (item) => formattedDatePp(item?.start_date),
    },
    {
      title: "End Date",
      getData: (item) => formattedDatePp(item?.end_date) || "-",
    },
    {
      title: "Document",
      getData: (item) =>
        item?.file_uuid && (
          <button
            className="bg-blue-600 text-white px-2 py-1"
            onClick={() => setPreviewData(item)}
          >
            Preview
          </button>
        ),
    },
    {
      title: "Description",
      getData: (item) => capitalizeFirstLetter(item?.description),

    },
  ];
  const footerList = [
    {
      title: "Close",
      type: "cancel",
      action: () => {
        setPreviewData(false);
      },
    },
  ];
  let fileUrl = `${getBaseUrl()}/messages/read_attachment.json?uuid=${
    previewData && previewData.file_uuid
  }&token=${userData?.token}&tz=${new Date().getTimezoneOffset()}`;


  return (
    <div>
      {previewData && (
        <MainPageDialog
          title="Consent Document"
          modalSize="md"
          maxHeight={true}
          footerList={footerList}
          onCancelHandler={() => setPreviewData(null)}
        >
          <img src={fileUrl} />
          {/* <div dangerouslySetInnerHTML={{ __html: html }}></div> */}
        </MainPageDialog>
      )}
      <div className="flex rounded border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
        <p className="text-lg font-bold">Consent</p>
        <div onClick={crossHandler}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>
      <div className="mt-3">
        <AppListing
          loading={isLoading}
          listData={consentData?.data?.active || []}
          cols={cols}
        />
      </div>
    </div>
  );
}

export default Consent;
